import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const MemberGotOutCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `لقد غادر ${sender?.name} قناة مشتركه بينكم`
          : `${sender?.name} has left a channel you are in`
      }
    />
  )
}

export default MemberGotOutCover
